module.exports = __webpack_public_path__ + "static/media/community11.76a2a889.svg";